"use strict";

exports.__esModule = true;
exports.validateUkPostcode = exports.validateRequired = exports.validateNumber = exports.validateName = exports.validateMinLength = exports.validateMaxLength = exports.validateMatchesField = exports.validateLocalPhoneNumber = exports.validateLocalMobilePhoneNumber = exports.validateIsYear = exports.validateIsNationalInsuranceNumber = exports.validateIsDate = exports.validateInternationalPhoneNumber = exports.validateEmail = exports.validateDoesNotContainField = exports.validateContainsUppercaseCharacter = exports.validateContainsSpecialCharacter = exports.validateContainsNumber = exports.validateContainsLowercaseCharacter = exports.validateAlphaNumeric = exports.validateAbsoluteLength = void 0;

var _emailValidator = _interopRequireDefault(require("email-validator"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const validateRequired = value => value ? undefined : 'Required';

exports.validateRequired = validateRequired;

const validateAlphaNumeric = value => !/^[a-zA-Z0-9]{1,}$/gi.test(value) ? 'Only alphanumeric characters' : undefined;

exports.validateAlphaNumeric = validateAlphaNumeric;

const validateNumber = value => isNaN(Number(value)) ? 'Must be a number' : undefined;

exports.validateNumber = validateNumber;

const validateMaxLength = max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined;

exports.validateMaxLength = validateMaxLength;

const validateMinLength = min => value => value && value.length < min ? `Must be ${min} characters or more` : undefined;

exports.validateMinLength = validateMinLength;

const validateAbsoluteLength = absolute => value => value && value.length !== absolute ? `Must be ${absolute} characters` : undefined;

exports.validateAbsoluteLength = validateAbsoluteLength;

const validateContainsUppercaseCharacter = value => !/[A-Z]/.test(value) ? 'Must contain an uppercase character' : undefined;

exports.validateContainsUppercaseCharacter = validateContainsUppercaseCharacter;

const validateContainsLowercaseCharacter = value => !/[a-z]/.test(value) ? 'Must contain a lowercase character' : undefined;

exports.validateContainsLowercaseCharacter = validateContainsLowercaseCharacter;

const validateContainsNumber = value => !/[0-9]/.test(value) ? 'Must contain a number' : undefined;

exports.validateContainsNumber = validateContainsNumber;

const validateEmail = value => !_emailValidator.default.validate(value) ? 'Must be a valid email' : undefined;

exports.validateEmail = validateEmail;

const validateLocalPhoneNumber = value => !/^[0-9]{10,}$/gi.test(value.replace(/\s/g, '')) ? 'Must be a valid phone number' : undefined;

exports.validateLocalPhoneNumber = validateLocalPhoneNumber;

const validateInternationalPhoneNumber = value => !/^\+?[0-9]{10,}$/gi.test(value.replace(/\s/g, '')) ? 'Must be a valid mobile number' : undefined;

exports.validateInternationalPhoneNumber = validateInternationalPhoneNumber;

const validateLocalMobilePhoneNumber = value => !/^07[0-9]{9}$/gi.test(value.replace(/\s/g, '')) ? 'Must be a valid mobile number' : undefined;

exports.validateLocalMobilePhoneNumber = validateLocalMobilePhoneNumber;

const validateName = value => !/^[a-zA-Z'\-\s]{1,}$/gi.test(value) ? 'Must be a valid name' : undefined;

exports.validateName = validateName;

const validateMatchesField = name => (value, allValues) => allValues && allValues[name] && allValues[name] !== value ? 'Field values must match' : undefined;

exports.validateMatchesField = validateMatchesField;

const validateDoesNotContainField = name => (value, allValues) => allValues && allValues[name] && value && value.indexOf(allValues[name]) !== -1 ? `Field must not contain the value of the field '${name}'` : undefined;

exports.validateDoesNotContainField = validateDoesNotContainField;

const validateIsDate = value => value && value.length === 10 && (0, _moment.default)(value, "DD/MM/YYYY").isValid() ? undefined : 'Please enter a valid date (DD/MM/YYYY)';

exports.validateIsDate = validateIsDate;

const validateIsYear = value => !/^[0-9]{4}$/gi.test(value) ? 'Must be a year' : undefined;

exports.validateIsYear = validateIsYear;

const validateIsNationalInsuranceNumber = value => !/[A-Z]{2}\d{6}[A-Z]$/gi.test(value) ? 'Must be a valid National Insurance number' : undefined;

exports.validateIsNationalInsuranceNumber = validateIsNationalInsuranceNumber;

const validateContainsSpecialCharacter = value => !/[^a-z0-9]/gi.test(value) ? 'Must contain a special character such as: @ # ! $ &' : undefined;

exports.validateContainsSpecialCharacter = validateContainsSpecialCharacter;

const validateUkPostcode = value => !/^(([G][I][R] {0,}0[A]{2})|(([A][S][C][N]|[S][T][H][L]|[T][D][C][U]|[B][B][N][D]|[B][I][Q][Q]|[F][I][Q][Q]|[P][C][R][N]|[S][I][Q][Q]|[T][K][C][A]) {0,}1[Z]{2})|((([A-PR-UWYZ][A-HK-XY]?[0-9][0-9]?)|(([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRV-Y]))) {0,}[0-9][ABD-HJLNP-UW-Z]{2}\s*))$/gi.test(value) ? 'Must be a valid UK postcode' : undefined;

exports.validateUkPostcode = validateUkPostcode;